import React from 'react';

import { useIntl } from 'react-intl-next';

import FeedbackIcon from '@atlaskit/icon/core/feedback';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Text, xcss } from '@atlaskit/primitives';
import UFOSegment from '@atlaskit/react-ufo/segment';
import { token } from '@atlaskit/tokens';
import type { ExperimentConfig } from '@atlassian/search-experiment/types';

import type { ApplicationModes } from '../../constants/application-modes';
import type { PrimaryProductKey, ProductKeys } from '../../constants/products';
import type { UserDetailsWithPicture, UserDetailsWithStatus } from '../../constants/types';
import { getUser } from '../../utils/bootstrap';
import { getUnifiedSearchRightRailEnhancementsExpValue } from '../../utils/experiments';
import FeedbackComponent from '../feedback';

import { messages } from './messages';

const dividerStyles = xcss({
	borderTop: `${token('border.width')} solid ${token('color.border')}`,
	height: '1px',
	marginBlock: 'space.075',
	marginInline: 'space.150',
});

const wrapperStyles = xcss({
	alignItems: 'center',
	display: 'flex',
	font: token('font.body'),
	gap: 'space.075',
	marginTop: 'space.100',
	paddingBlock: 'space.050',
	paddingLeft: 'space.150',
});

const feedbackIconContainer = xcss({
	padding: 'space.050',
	justifyContent: 'center',
});

export type GiveFeedbackProps = {
	cloudId?: string;
	primaryProduct?: PrimaryProductKey;
	experimentConfig: ExperimentConfig;
	selectedProducts: ProductKeys[];
	user?: UserDetailsWithPicture | UserDetailsWithStatus;
	appMode: ApplicationModes;
	requestId?: string;
	traceId?: string;
	isCQL?: boolean;
};

export const GiveFeedback = ({
	cloudId,
	primaryProduct,
	experimentConfig,
	selectedProducts,
	user,
	appMode,
	requestId,
	traceId,
	isCQL,
}: GiveFeedbackProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<UFOSegment name="search-page-feedback">
			{getUnifiedSearchRightRailEnhancementsExpValue() !== 'single-select' && (
				<Box xcss={dividerStyles} />
			)}
			<Box xcss={[wrapperStyles]}>
				<Box xcss={feedbackIconContainer}>
					<FeedbackIcon color="currentColor" label="Give feedback" />
				</Box>
				<Text>{formatMessage(messages.improveSearch)}</Text>
				<FeedbackComponent
					cloudId={cloudId}
					primaryProduct={primaryProduct}
					experimentConfig={experimentConfig}
					selectedProducts={selectedProducts}
					user={getUser(user)}
					applicationMode={appMode}
					source="search-page"
					appearance="link"
					requestId={requestId || ''}
					traceId={traceId || ''}
					isCQL={isCQL}
				/>
			</Box>
		</UFOSegment>
	);
};
